import React from 'react'
import "./RadioRowInput.scss";

export default function RadioRowInput({
  isActive,
  value,
  label,
  onClick,
  error = false,
}: RadioRowInputProps) {
  return (
    <div className='_radioRowInput'>
      {!isActive ? (
        <label
          onClick={() => {
            onClick(value)
          }}
          className={`_btn ${
            error ? 'border-danger text-danger' : ''
          }`}
        >
          <span className='fw-bold'>{label}</span>
        </label>
      ) : (
        <label
          className={`_btn _checked  ${
            error ? 'border-danger text-danger' : ''
          }`}
        >
          <span className='fw-bold'>{label}</span>
        </label>
      )}
    </div>
  )
}

interface RadioRowInputProps {
  isActive: boolean
  value: string
  label: string
  onClick: (value: string) => void
  error?: boolean
}
